var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),_c('div',{staticClass:"section-container"},[_c('side-nav',{staticClass:"side-nav",attrs:{"menuItems":_vm.menuItems}}),_c('div',{staticClass:"content-box"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }